import React, { Component } from 'react';

export class Calendar extends Component {
    static displayName = Calendar.name;

    constructor(props) {
        super(props);
        this.state = {
            componentId: props.componentId,
            format: null
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    render() {
        let format = this.state.format;

        var date = new Date();
        var month = date.getMonth();
        var day = date.getDate();
        var year = date.getFullYear();
        var weekDay = date.getDay();
        var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

        var weekDayString = weekDays[weekDay];
        var dateString;
        switch (format) {
            case "M/D/YY":
                dateString = (month + 1) + "/" + day + "/" + year;
                break;
            case "Month D, YY":
                dateString = months[month] + " " + day + ", " + year;
                break;
            default:
                break;
        }

        return (
            <div className='calendar-wrapper'>
                {weekDayString}
                <br />
                {dateString}
            </div>
        );
    }

    async getComponentData() {
        const response = await fetch('Components/GetCalendar?componentId=' + this.state.componentId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        if (data != null) {
            this.setState({
                format: data.format
            });
        }
    }
}
